module.exports = __webpack_public_path__ + "static/media/DSCF1582.8b6f5ed5.jpg";